import ClipboardJS from 'clipboard';

new ClipboardJS('[data-clipboard-target]', {
  text: ({ dataset: { clipboardTarget } }) => {
    const { value, innerHTML } = document.querySelector(clipboardTarget);
    return value || innerHTML;
  },
});
